export default {
  banner_v2: {
    title: '<span class={title}>Receba <span class={highlight}>US$100</span> e muito mais durante a Temporada de Recompensas DSers</span>',
    desc: `A Temporada de Recompensas DSers será realizada entre 15 de outubro e 15 de janeiro. <br />
      Os convites serão enviados para vendedores aleatoriamente em setembro. <br />
      Verifique a caixa de entrada do e-mail que você usou para criar sua conta DSers.`,
    learn_more: 'Saiba mais'
  }
};
